var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"10px","text-align":"left"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.createTemplate}},[_vm._v("新增")]),_c('configDialog',{ref:"configDialog",attrs:{"printBusinessType":_vm.printBusinessType},on:{"overEmit":function($event){return _vm.$emit('overEmit')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }